// import sendLog1 from "./sendLog1";
import sendLog2 from "./sendLog2";

export const logPageAccess = (pathname: string, isDevEnv: boolean) => {
  if (!pathname || pathname === "/" || isDevEnv) return;

  const pathSegments = pathname?.split?.("/")?.filter?.(Boolean) ?? [];
  const pathName = pathSegments?.join?.("_");
  const logPrefix = "index_";
  const action = logPrefix + pathName;
  // sendLog1(logPrefix + pathName);
  sendLog2({
    action,
    pathname,
  });
};
